//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { RepState } from './Enums';

export class TestRepertoireInputItem extends ItemBase {
    TeacherIndex: number = 0;
    StudentIndices: number[] = [];
    Title: string | null = null;
    Composer: string | null = null;
    Description: string | null = null;
    Duration: number | null = null;
    Notes: string | null = null;
    Source: string | null = null;
    Instrument: string | null = null;
    Genre: string | null = null;
    Difficulty: string | null = null;
    Language: string | null = null;
    Status: RepState | null = null;

    constructor(initializer?: Partial<TestRepertoireInputItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "TestRepertoireInputItem";
}
